import {useNavigation, useRoute} from '@react-navigation/native';
import React from 'react';
import {SafeAreaView} from 'react-native-safe-area-context';

import {Header} from '../../../components/Interface/Headers/Header';
import {Titles} from '../../../components/Interface/Typographies/Titles';
import {Button as ButtonFooter} from '../../../components/Interface/Forms/Buttons/Button';

import {Container, Content, Footer, LinkButtonContainer} from './styles';
import {LinkButton} from '../../../components/Interface/Forms/Buttons/LinkButton';

interface Params {
  message: string;
}

export function ClubeNotEligible() {
  const navigation = useNavigation();

  const route = useRoute();

  const {message} = route.params as Params;

  return (
    <Container>
      <Header icon="x" action={() => navigation.navigate('Initial')} />
      <Content>
        <Titles
          title="Não perca o maior clube de vantagens do Brasil!"
          subtitle={message}
        />
        <LinkButtonContainer>
          <LinkButton
            enabled
            text="Como funciona o clube?"
            action={() => navigation.navigate('HowTo')}
          />
        </LinkButtonContainer>
      </Content>
      <Footer>
        <SafeAreaView>
          <ButtonFooter
            title="Entendido"
            enabled
            onPress={() => navigation.navigate('Initial')}
          />
        </SafeAreaView>
      </Footer>
    </Container>
  );
}
